import {
  DiscountApplicableProduct,
  SubscriptionItemType,
  SubscriptionType,
} from "@/primary-models";

export const SUBSCRIPTION_TYPE_TO_DISCOUNT_PRODUCT = {
  [SubscriptionType.FRESH]: DiscountApplicableProduct.FRESH_MEAL_PLAN,
  [SubscriptionType.SCOOP_PLANET]: null,
  [SubscriptionType.SCOOP_HEALTH]: null,
} as const satisfies Record<
  SubscriptionType,
  DiscountApplicableProduct | null
>;
export const ITEM_TYPE_TO_DISCOUNT_PRODUCT = {
  [SubscriptionItemType.CLUCK]: null,
  [SubscriptionItemType.GOBBLE]: null,
  [SubscriptionItemType.SHREDDED_CLUCK]: null,
  [SubscriptionItemType.SHREDDED_GOBBLE]: null,
  [SubscriptionItemType.QUACK]: null,
  [SubscriptionItemType.OINK]: null,
  [SubscriptionItemType.SPLASH]: null,
  [SubscriptionItemType.BAAA]: null,
  [SubscriptionItemType.MOOO]: null,
  [SubscriptionItemType.SPRINKLES]: DiscountApplicableProduct.CHICKEN_SPRINKLES,
  [SubscriptionItemType.NIBBLES_CHICKEN]: DiscountApplicableProduct.CHICKEN_NIBBLES,
  [SubscriptionItemType.NIBBLES_SALMON]: DiscountApplicableProduct.SALMON_NIBBLES,
  [SubscriptionItemType.NIBBLES_CHICKEN_POUCH]: DiscountApplicableProduct.CHICKEN_NIBBLES_POUCH,
  [SubscriptionItemType.NIBBLES_SALMON_POUCH]: DiscountApplicableProduct.SALMON_NIBBLES_POUCH,
  [SubscriptionItemType.NIBBLES_TUNA_POUCH]: DiscountApplicableProduct.TUNA_NIBBLES_POUCH,
  [SubscriptionItemType.SCOOP_HEALTH]: DiscountApplicableProduct.HEALTH_SCOOP,
  [SubscriptionItemType.SCOOP_PLANET]: DiscountApplicableProduct.PLANET_SCOOP,
  [SubscriptionItemType.TOTE_BAG]: null,
} as const satisfies Record<
  SubscriptionItemType,
  DiscountApplicableProduct | null
>;
